import React from 'react';
import './PublicationsList.css';

const publications = [
  {
    title: 'How To Think About End-To-End Encryption and AI: Training, Processing, Disclosure, and Consent',
    authors: 'Mallory Knodel, Andrés Fábrega, Daniella Ferrari, Jacob Leiken, Betty Li Hou, Derek Yen, Sam de Alfaro, Kyunghyun Cho, Sunoo Park',
    venue: 'RWC 2025',
    year: 2025,
    link: 'https://arxiv.org/abs/2412.20231',
  },
  {
    title: 'Human development, societal stability and bird capital predict global tourist eBirding activity',
    authors: 'Natalia Ocampo-Peñuela, Sam de Alfaro, Montague H. C. Neate-Clegg, Luca de Alfaro, Katarina Bjegovic, R. Scott Winton',
    venue: 'People and Nature',
    year: 2025,
    link: 'https://doi.org/10.1002/pan3.70105',
  }
];

const PublicationsList = () => {
  return (
    <div className="publications-container">
      <div className="publications-screen">
        <div className="screen-header">✿ PUBLICATIONS ✿</div>
        <div className="publications-body">
          {publications && publications.length > 0 ? (
            <div className="publications-list">
              {publications.map((pub, index) => (
                <div key={index} className="publication-item">
                  <div className="pub-number">#{index + 1}</div>
                  <div className="pub-content">
                    <div className="pub-title">{pub.title}</div>
                    {pub.authors && (
                      <div className="pub-authors">{pub.authors}</div>
                    )}
                    {pub.venue && (
                      <div className="pub-venue">{pub.venue}</div>
                    )}
                    {pub.year && (
                      <div className="pub-year">({pub.year})</div>
                    )}
                    {pub.link && (
                      <a href={pub.link} target="_blank" rel="noopener noreferrer" className="pub-link">
                        → VIEW PAPER
                      </a>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="empty-publications">
              <div className="pixel-text">No publications yet!</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PublicationsList;
